import { exists } from '@/api'

export interface BatchTrcContentDetailUpdateCondition {
  startNumFrom: string
  startNumTo: string
  materialFormat: string
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  contentDetailTitleFile: string
  contentDetailDisplayAuthorFile: string
  memo: string
}

export function BatchTrcContentDetailUpdateConditionFromJSON(
  json: any
): BatchTrcContentDetailUpdateCondition {
  const _json = JSON.parse(json)

  return {
    startNumFrom: exists(_json, 'start_num_from') ? _json.start_num_from : '',
    startNumTo: exists(_json, 'start_num_to') ? _json.start_num_to : '',
    materialFormat: exists(_json, 'material_format')
      ? _json.material_format
      : '',
    convertHyoukiToFull: exists(_json, 'convert_hyouki_to_full')
      ? _json.convert_hyouki_to_full
      : false,
    convertKanaToHalf: exists(_json, 'convert_kana_to_half')
      ? _json.convert_kana_to_half
      : false,
    contentDetailTitleFile: exists(_json, 'content_detail_title_file')
      ? _json.content_detail_title_file
      : '',
    contentDetailDisplayAuthorFile: exists(
      _json,
      'content_detail_display_author_file'
    )
      ? _json.content_detail_display_author_file
      : '',
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
